import { useDeferredValue, useState } from 'react';
import { type Person, useOrgSearch } from '../api/org';
import { Avatar } from './Avatar';

/** Выбор сотрудника поиском по ФИО или должности. */
export function EmployeePicker({
  label,
  value,
  onChange,
}: {
  label: string;
  value: Person | null;
  onChange: (person: Person | null) => void;
}) {
  const [query, setQuery] = useState('');
  const deferred = useDeferredValue(query);
  const search = useOrgSearch(deferred);
  const [open, setOpen] = useState(false);

  if (value) {
    return (
      <div className="field">
        <span>{label}</span>
        <div className="person-card">
          <Avatar name={value.fullName} photoUrl={value.photoUrl} />
          <span className="text">
            <b>{value.fullName}</b>
            <small>{value.position ?? ''}</small>
          </span>
          <button type="button" className="link" onClick={() => onChange(null)}>
            Изменить
          </button>
        </div>
      </div>
    );
  }

  const results = query.trim().length >= 2 ? (search.data?.employees ?? []) : [];
  return (
    <label className="field picker">
      <span>{label}</span>
      <input
        className="input"
        type="search"
        placeholder="ФИО или должность"
        value={query}
        onChange={(event) => {
          setQuery(event.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
      />
      {open && results.length ? (
        <div className="picker-list" role="listbox">
          {results.slice(0, 20).map((person) => (
            <button
              key={person.id}
              type="button"
              role="option"
              aria-selected="false"
              className="member"
              onClick={() => {
                onChange(person);
                setQuery('');
                setOpen(false);
              }}
            >
              <Avatar name={person.fullName} photoUrl={person.photoUrl} />
              <span className="member-text">
                <b>{person.fullName}</b>
                <small>{person.position ?? ''}</small>
              </span>
            </button>
          ))}
        </div>
      ) : null}
    </label>
  );
}
